export default __webpack_public_path__ + "static/media/dismiss_service.b8dd0ce6.svg";